import { gql } from '@apollo/client'

export const GET_SUBSCRIPTION_PLANS = gql`
    query getSubscriptionPlans($filter: SubscriptionPlanFilterInput, $page: PageInput!) {
        getSubscriptionPlans(filter: $filter, page: $page) {
            code
            success
            message
            total_count
            subscription_plans {
                subscription_id
                subscription_name {
                    en
                    ar
                }
                description {
                    en
                    ar
                }
                period_code
                period {
                    code
                    description {
                        en
                        ar
                    }
                    duration_days
                }
                amount
                currency
                category_code
                category {
                    code
                    description {
                        en
                        ar
                    }
                }
                routes {
                    route_id
                    route_name {
                        en
                        ar
                    }
                    seat_types
                    included
                }
                trips {
                    trip_id
                    trip_name {
                        en
                        ar
                    }
                    route_id
                    time_slots
                    days_of_week
                    included
                }
                benefits {
                    number_of_trips
                    unlimited_trips
                    miles
                    miles_per_trip
                    discount_percentage
                    companion_discount
                    priority_boarding
                    lounge_access
                    free_luggage_kg
                    free_meal
                    cancellation_flexibility {
                        free_cancellation_hours
                        refund_percentage
                    }
                    upgrade_options {
                        free_upgrades
                        upgrade_discount
                    }
                }
                valid_from
                valid_to
                status_code
                status {
                    code
                    description {
                        en
                        ar
                    }
                }
                metadata {
                    promo_code
                    max_subscribers
                    current_subscribers
                    featured
                    display_order
                    terms_conditions {
                        en
                        ar
                    }
                    image_url
                }
                user_audit {
                    created_by
                    created_date
                    modified_by
                    modified_date
                }
                is_active
                is_editable
            }
        }
    }
`


export const GET_SUBSCRIPTION_STATUS = gql`
    query subscriptionStatus($code: String) {
        subscriptionStatus(code: $code) {
            code
            description {
                en
                ar
            }
        }
    }
`

export const GET_SUBSCRIPTION_PERIOD = gql`
    query subscriptionPeriod($code: String) {
        subscriptionPeriod(code: $code) {
            code
            description {
                en
                ar
            }
            duration_days
        }
    }
`

export const GET_ROUTE_TYPE = gql`
    query routeType($code: String) {
        routeType(code: $code) {
            code
            description {
                en
                ar
            }
        }
    }
`
